import React from 'react';
import PropTypes from 'prop-types';

import {Typography} from 'views/components';
import {Map, Translate} from 'views/module';

const ContentView = (props) => {
  const bioQuestion = props.bioQuestion;

  const {questionData: {latitude, longitude}} = bioQuestion;

  const hasData = latitude || longitude;

  if (hasData) {
    return (
      <Map
        width = '100%'
        height = '200px'
        coordinates = { [latitude, longitude]}
      />
    );
  } else {
    return (
      <Typography>
        <Translate expression='caregiver.CaregiverDetail.Biography.Questions.Empty' />
      </Typography>
    );
  }
};

ContentView.propTypes = {
  bioQuestion: PropTypes.shape({
    bioQuestionId: PropTypes.string.isRequired,
    questionData: PropTypes.shape({
      latitude: PropTypes.number.isRequired,
      longitude: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
};

export default ContentView;
